export default "__VITE_ASSET__edf7c958__"